import { SMSessionDTO } from 'api/interfaces/snapshot';

export interface SessionsMessage {
  readonly Sessions: readonly SMSessionDTO[];
}

export const isSessionsMessage = (message: any | SessionsMessage): message is SessionsMessage => {
  return 'Sessions' in message;
};
